import React from 'react';
import { IconProps } from '@/components/Icons/types/IconInterface';
import cn from '@/utils/cn';
import { iconVariant } from '@/components/Icons/iconVariant';

interface InformationIconProps extends IconProps {
  backgroundColor?: string;
}

const InformationIcon = ({ size, variant, className, backgroundColor }: InformationIconProps) => {
  return (
    <svg
      className={cn(iconVariant({ variant, size, className }))}
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="35" cy="35" r="35" fill={backgroundColor ?? `#5A31F4`} />
      <path
        d="M29.4667 50.5262C29.7913 50.8421 30.1836 51 30.6435 51H41.3565C41.8164 51 42.2019 50.8421 42.513 50.5262C42.8377 50.1961 43 49.7869 43 49.2988C43 48.825 42.8377 48.4302 42.513 48.1144C42.2019 47.7842 41.8164 47.6191 41.3565 47.6191H37.7652V32.5451C37.7652 31.9134 37.6164 31.4038 37.3188 31.0162C37.0213 30.6285 36.5884 30.4347 36.0203 30.4347H31.029C30.5691 30.4347 30.1768 30.5998 29.8522 30.93C29.5411 31.2602 29.3855 31.655 29.3855 32.1144C29.3855 32.6025 29.5411 33.0117 29.8522 33.3419C30.1768 33.6577 30.5691 33.8156 31.029 33.8156H34.2145V47.6191H30.6435C30.1836 47.6191 29.7913 47.7842 29.4667 48.1144C29.1556 48.4302 29 48.825 29 49.2988C29 49.7869 29.1556 50.1961 29.4667 50.5262Z"
        fill="white"
      />
      <path
        d="M32.9362 24.5774C33.5314 25.2091 34.2551 25.5249 35.1072 25.5249C35.9729 25.5249 36.7034 25.2091 37.2986 24.5774C37.8937 23.9457 38.1913 23.1777 38.1913 22.2732C38.1913 21.3544 37.8937 20.5792 37.2986 19.9475C36.7034 19.3158 35.9729 19 35.1072 19C34.2551 19 33.5314 19.3158 32.9362 19.9475C32.3411 20.5792 32.0435 21.3544 32.0435 22.2732C32.0435 23.1777 32.3411 23.9457 32.9362 24.5774Z"
        fill="white"
      />
    </svg>
  );
};

export default InformationIcon;
